import $ from "jquery";
$(document).ready(function(){
    // Check if there is a component on the page first
    if ((document.getElementsByClassName('c-image-inline').length) && (document.getElementsByClassName('pull-into-hero').length) && (document.querySelector('.sl-main-ribbon') == null)) {
        $(window).on("load resize", function() {
            // Get item we want to move
            let targetToMove = $('.c-image-inline.pull-into-hero');
            // Get item we want to move into
            let targetToExpand = $('.c-hero-wrapper');
            // Find height of the item
            let componentHeight = $('.c-image-inline').height();
            // Get a third of that height + the padding to the top of the container its in
            let componentHeightThird = componentHeight * 0.33;
            // + the padding to the top of the container its in
            let componentHeightThirdPlusGap = (componentHeightThird + 64);
            // Update main wrapper to allow overlapping
            $('.grid-container.fluid').css('overflow','visible');
            // Move target up
            targetToMove.css('margin-top',-componentHeightThirdPlusGap).css('transition','all 1.125s!important');
            // Create space for target to fill
            targetToExpand.css('padding-bottom',componentHeightThird);
        });
    }
});

$(document).ready(function(){
    // Check if there is a component on the page first
    if ((document.getElementsByClassName('pull-into-hero').length) && (document.querySelector('.sl-main-ribbon') == null)) {
        $(window).on("load resize", function() {
            // Get item we want to move
            let targetToMove = $('.pull-into-hero');
            // Get item we want to move into
            let targetToExpand = $('.c-hero-wrapper');
            // Find height of the item
            let componentHeight = $('.pull-into-hero').height();
            // Get a third of that height + the padding to the top of the container its in
            let componentHeightThird = componentHeight * 0.33;
            // + the padding to the top of the container its in
            let componentHeightThirdPlusGap = (componentHeightThird + 64);
            // Update main wrapper to allow overlapping
            $('.grid-container.fluid').css('overflow','visible');
            // Move target up
            targetToMove.css('margin-top',-componentHeightThirdPlusGap).css('transition','all 0.125s');
            // Create space for target to fill
            targetToExpand.css('padding-bottom',componentHeightThird);
        });
    }
});

$(document).ready(function(){
    // Get all the zoomable image-inline components
    const zoomable = document.querySelectorAll('.c-image-inline[data-zoomable]');

    if (zoomable.length) {

        // Create a wrapper to hold the modals
        const revealFragment = document.createDocumentFragment();


        // Look around the zoomable components
        for (let i=0; i < zoomable.length; i++) {

            // Add a class to show it's zoomable for styling
            zoomable[i].classList.add('is-zoomable');

            // Create the modal element with the necessary classes and attributes
            let newReveal = document.createElement("section");
            newReveal.setAttribute('class', 'reveal');
            newReveal.setAttribute('data-reveal', '');
            newReveal.setAttribute('data-close', '');
            newReveal.setAttribute('data-animation-in', 'fade-in');
            newReveal.setAttribute('data-additional-overlay-classes', 'reveal-overlay--dark reveal-overlay--full-size reveal-overlay--zoomable-image');

            // Clone the image inline component
            let modalSource = zoomable[i].getElementsByTagName('img');
            let modalContent = modalSource[0].cloneNode(true);

            // Allow the whole component to close the modal
            modalContent.setAttribute('data-close', '');

            // Create a new ID to link the component to the modal
            let newRevealID = 'zoomable' + (i+1);

            // Add the ID to the modal
            newReveal.setAttribute('id', newRevealID);

            // Append the cloned component inside the modal element
            newReveal.appendChild(modalContent);

            // Append the modal to the wrapper
            revealFragment.appendChild(newReveal);

            // Update the image inline component with the trigger to open the corresponding modal
            zoomable[i].setAttribute('data-open', newRevealID);
        }

        // Append the wrapper to the document
        document.body.appendChild(revealFragment);

        // Reinitialise Foundation
        $(document).foundation();
    };
});